export const teamData = {
  members: [
    {
      name: "Naveenraj Thiyagarajan",
      position: "Lead & SDE",
      image: require("../assets/team/naveenraj.png"),
      socials: {
        github: "https://github.com/navi-04",
        linkedin: "http://www.linkedin.com/in/navithiyagu",
        instagram: "https://www.instagram.com/naveenraj.thiyagarajan",
      }
    },
    //     {
    //   name: "Suvitha",
    //   position: "Graphic Designer",
    //   image: require("../assets/team/suvitha.jpeg"),
    //   socials: {
    //     github: "https://github.com/SuvithaaaaR",
    //     linkedin: "https://www.linkedin.com/in/suvitha-ramesh/",
    //     instagram: "#",
    //   },
    // },
        {
      name: "Nirmala",
      position: "Media Manager & SDE",
      image: require("../assets/team/nirmala.jpg"),
      socials: {
        github: "https://github.com/nirmalaramadass",
        linkedin: "https://www.linkedin.com/in/nirmala-ramadas-16b081290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        instagram: "#",
      },
    },
        {
      name: "Vishnu",
      position: "Chief Software Engineer",
      image: require("../assets/team/vishnu.jpeg"),
      socials: {
        github: "https://github.com/nirmalaramadass",
        linkedin: "https://www.linkedin.com/in/nirmala-ramadas-16b081290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        instagram: "#",
      },
    },
    // {
    //   name: "Nureshma",
    //   position: "SDE",
    //   image: require("../assets/team/nureshma.jpg"),
    //   socials: {
    //     github: "https://github.com/Reshma-2006",
    //     linkedin: "http://www.linkedin.com/in/nureshma-s-full-stack-developer-a03444290/",
    //     instagram: "#",
    //   },
    // },
    //  {
    //   name: "Rahul",
    //   position: "Sales Intern",
    //   image: require("../assets/team/rahul1.jpeg"),
    //   socials: {
    //     github: "https://github.com/RAHUL-DevelopeRR",
    //     linkedin: "https://www.linkedin.com/in/rahulsrinivasan7",
    //   },
    // },
      
    // {
    //   name: "Shivani",
    //   position: "Event Manager",
    //   image: require("../assets/team/shivani.jpeg"),
    //   socials: {
    //     github: "https://github.com/Shivani-rajalakshmi",
    //     linkedin: "https://www.linkedin.com/in/shivani-karthikeyan-400508283?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    //     instagram: "#",
    //   },
    // },
    // {
    //   name: "Swathi",
    //   position: "SDE",
    //   image: require("../assets/team/swathi.jpeg"),
    //   socials: {
    //     github: "https://github.com/SWATHI-63",
    //     linkedin: "https://www.linkedin.com/in/swathi-sundharaj-2a7242312",
    //     instagram: "#",
    //   },
    // },
    // {
    //   name: "Sridevi",
    //   position: "SDE Intern",
    //   image: require("../assets/team/sridevi.jpeg"),
    //   socials: {
    //     github: " https://github.com/srisridevi1206",
    //     linkedin: "https://www.linkedin.com/in/sridevi-srinivasan-7860b7275?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    //     instagram: "https://www.instagram.com/iam._.sri1?igsh=MXV0cHVhNjM4d3Zxcg==",
    //   },
    // },
    // {
    //   name: "Priyadharshini",
    //   position: "SDE Intern",
    //   image: require("../assets/team/priyadharshini.jpeg"),
    //   socials: {
    //     github: "https://github.com/priyadharshini26806",
    //     linkedin: "https://www.linkedin.com/in/priyadharshini26806/",
    //     instagram: "https://www.instagram.com/priya__dharshzz?igsh=MTF1dHJlM2hyaDN1ZA==",
    //   },
    // },
    // {
    //   name: "Praveen Kumar",
    //   position: "Sales Intern",
    //   image: require("../assets/team/image.png"),
    //   socials: {
    //     github: "https://github.com/Praveenofficial12",
    //     linkedin: "https://www.linkedin.com/in/praveen-kumar-k-developer?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    //     instagram: "https://www.instagram.com/_praveen_12_kvg_?igsh=MXNrMjB2MmNwODVpbQ==",
    //   },
    // },
  
    // {
    //   name: "Mathesh",
    //   position: "Video Editor",
    //   image: require("../assets/team/image.png"),
    //   socials: {
    //     github: "",
    //     linkedin: "",
    //   },
    // },
  ],
};
